import { IconButton } from '@latitude/icon-button';
import { Icon } from '@latitude/icons';
import { cn } from '@latitude/token-utils';
import * as ToastPrimitives from '@radix-ui/react-toast';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * A component that represents the close button for a toast.
 *
 * @component
 * @example
 * ```tsx
 * <ToastClose className="custom-class" onClick={handleClose} />
 * ```
 */
export const ToastClose = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof ToastPrimitives.Close> & {
  ref?: Ref<ComponentRef<typeof ToastPrimitives.Close>>;
}) => (
  <ToastPrimitives.Close
    ref={ref}
    className={cn([], className)}
    toast-close=""
    asChild
    {...props}
  >
    <IconButton
      data-testid="toast-close"
      variant="strong"
      type="ghost"
      size="small"
      aria-label="Close"
      icon={<Icon name="x-close" />}
    />
  </ToastPrimitives.Close>
);
ToastClose.displayName = ToastPrimitives.Close.displayName;
